(() => {
  function boot() {
    const root = document.querySelector("[data-wl-atelier-product]");
    if (!root) return;
    document.body.classList.add("wl-atelier-product-active");

    if (root.dataset.apGroup === "true") return;

    // Carry the originating selector in the URL so refreshes and variant changes
    // keep the return destination, without relying on browser history.
    const groupHandle = new URL(window.location.href).searchParams.get("atelier_group");
    const backLink = root.querySelector("[data-ap-back]");
    if (backLink && groupHandle && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(groupHandle)) {
      const groupUrl = new URL(backLink.dataset.apProductsUrl + groupHandle, window.location.origin);
      groupUrl.searchParams.set("view", "atelier");
      groupUrl.hash = "atelier-pieces";
      backLink.href = groupUrl.href;
      backLink.classList.add("wl-ap-header__back--pieces");
      backLink.querySelector(".wl-ap-header__back-text").textContent = "Back to pieces";
    }

    let product = null;
    try {
      const node = root.querySelector("[data-ap-product]");
      product = JSON.parse(node ? node.textContent : "null");
    } catch (error) {
      console.error("[wl-atelier-product] product JSON parse failed", error);
    }
    if (!product) return;

    const taggedSoldOut = (product.tags || []).some((tag) => tag.trim().toLowerCase() === "soldout");
    if (taggedSoldOut) product.variants.forEach((variant) => { variant.available = false; });

    const optionGroups = [...root.querySelectorAll("[data-ap-option]")];
    const priceNode = root.querySelector("[data-ap-price]");
    const statusNode = root.querySelector("[data-ap-status]");
    const addButton = root.querySelector("[data-ap-add]");
    const buyButton = root.querySelector("[data-ap-buy]");
    const drawerOpener = root.querySelector("[data-cart-drawer-open]");

    const money = (cents) => {
      const value = cents / 100;
      const template =
        (window.Shopify && window.Shopify.money_format) || "${{amount}}";
      const formatted = value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return template.replace(/\{\{\s*amount[^}]*\}\}/, formatted).replace(/<[^>]+>/g, "");
    };

    /* --------------------------- variant picking -------------------------- */

    const initial =
      product.variants.find((variant) => String(variant.id) === root.dataset.apInitialVariant) ||
      product.variants.find((variant) => variant.available) || product.variants[0];
    const selected = initial ? [...initial.options] : [];
    let currentVariant = initial;
    let cartBusy = false;

    const findVariant = (options) =>
      product.variants.find((variant) =>
        variant.options.every((value, index) => value === options[index])
      );

    const setStatus = (message) => {
      if (statusNode) statusNode.textContent = message || "";
    };

    const renderState = () => {
      currentVariant = findVariant(selected) || null;
      const available = Boolean(currentVariant && currentVariant.available);

      optionGroups.forEach((group) => {
        const index = Number(group.dataset.apOption);
        const current = group.querySelector("[data-ap-option-current]");
        if (current) current.textContent = selected[index] || "";
        group.querySelectorAll("[data-ap-value]").forEach((button) => {
          const value = button.dataset.apValue;
          const isSelected = value === selected[index];
          button.classList.toggle("is-selected", isSelected);
          button.setAttribute("aria-pressed", String(isSelected));
          // Would picking this value (with the other selections held) be purchasable?
          const probe = [...selected];
          probe[index] = value;
          const match = findVariant(probe);
          button.classList.toggle("is-unavailable", !match || !match.available);
        });
      });

      if (priceNode && currentVariant) priceNode.textContent = money(currentVariant.price);
      if (addButton) {
        addButton.disabled = !available || cartBusy;
        addButton.textContent = !currentVariant
          ? "Unavailable"
          : available
            ? cartBusy
              ? "Adding…"
              : "Add to Cart"
            : "Sold out";
      }
      if (buyButton) buyButton.hidden = !available;

      if (currentVariant && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", currentVariant.id);
        window.history.replaceState({}, "", url);
      }
    };

    optionGroups.forEach((group) => {
      const index = Number(group.dataset.apOption);
      group.addEventListener("click", (event) => {
        const button = event.target.closest("[data-ap-value]");
        if (!button) return;
        selected[index] = button.dataset.apValue;
        setStatus("");
        renderState();
      });
    });

    /* ------------------------------ cart ---------------------------------- */

    const addToCart = async (thenCheckout) => {
      if (!currentVariant || !currentVariant.available || cartBusy) return;
      cartBusy = true;
      renderState();
      setStatus(thenCheckout ? "Heading to checkout…" : "");
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: currentVariant.id, quantity: 1 }] })
        });
        if (response.status === 422) {
          currentVariant.available = false;
          setStatus("Just sold out.");
          return;
        }
        if (!response.ok) {
          setStatus("Something went wrong — try again.");
          return;
        }
        if (thenCheckout) {
          window.location.href = "/checkout";
          return;
        }
        setStatus("");
        if (drawerOpener) drawerOpener.click();
      } catch (error) {
        console.error("[wl-atelier-product] cart action failed", error);
        setStatus("Something went wrong — try again.");
      } finally {
        cartBusy = false;
        renderState();
      }
    };

    if (addButton) addButton.addEventListener("click", () => addToCart(false));
    if (buyButton) buyButton.addEventListener("click", () => addToCart(true));

    /* ------------------------- mobile gallery dots ------------------------ */

    const track = root.querySelector("[data-ap-track]");
    const dots = [...root.querySelectorAll("[data-ap-dot]")];
    if (track && dots.length) {
      const update = () => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach((dot, dotIndex) => dot.classList.toggle("is-active", dotIndex === index));
      };
      track.addEventListener("scroll", update, { passive: true });
      dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          track.scrollTo({ left: index * track.clientWidth, behavior: "smooth" });
        });
      });
    }

    renderState();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
